import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const selectTournamentUserSlice = createSelector(
  (state: RootState) => state.players,
  (state) => state,
);

export const selectPlayerEvents = (userId: number) =>
  createSelector([selectTournamentUserSlice], (state) => state.events[userId] ?? []);

export const selectProcess = createSelector([selectTournamentUserSlice], (state) => ({
  isProcessing: state.isProcessing,
  isProcessed: state.isProcessed,
  name: state.processName,
}));

export const selectMomentsPaginationData = createSelector([selectTournamentUserSlice], (state) => ({
  perPage: state.moments.perPage,
  currentPage: state.moments.currentPage,
  pages: state.moments.pages,
  allDataLoaded: state.moments.allDataLoaded,
  limit: state.moments.loadLimit,
}));

export const selectPlayerEventsOnPage = (userId: number) =>
  createSelector([selectTournamentUserSlice, selectPlayerEvents(userId)], (state, events) => {
    const currentPage = state.moments.currentPage;
    const perPage = state.moments.perPage;

    return events.slice((currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage);
  });

export const selectCurrentPlayerId = createSelector([selectTournamentUserSlice], (state) => state.currentPlayerId);
